import { render, staticRenderFns } from "./form_pass.vue?vue&type=template&id=08aec193&scoped=true&"
import script from "./form_pass.vue?vue&type=script&lang=js&"
export * from "./form_pass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aec193",
  null
  
)

export default component.exports